import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPpt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 0.5H11.793L15.5 4.207V14.5C15.5 15.052 15.052 15.5 14.5 15.5H5.5C4.948 15.5 4.5 15.052 4.5 14.5V1.5C4.5 0.948 4.948 0.5 5.5 0.5Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.788 0.5L15.5 4.223V4.5H11.5V0.5H11.788Z",
			stroke: "#C2C7D1"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 14,
			height: 8,
			rx: 1.5,
			fill: "#EE9743"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.53 7.899V8.625H11.303V12H10.44V8.625H9.208V7.899H12.53Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.434 10.525H6.563V12H5.712V7.899H7.498C7.91 7.899 8.238 8.005 8.483 8.216C8.728 8.428 8.85 8.755 8.85 9.198C8.85 9.682 8.728 10.025 8.483 10.225C8.238 10.425 7.888 10.525 7.434 10.525ZM7.835 9.671C7.946 9.573 8.002 9.417 8.002 9.204C8.002 8.991 7.945 8.838 7.832 8.748C7.721 8.657 7.564 8.611 7.362 8.611H6.563V9.819H7.362C7.564 9.819 7.722 9.77 7.835 9.671Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.577 10.525H2.706V12H1.854V7.899H3.641C4.052 7.899 4.381 8.005 4.625 8.216C4.87 8.428 4.993 8.755 4.993 9.198C4.993 9.682 4.87 10.025 4.625 10.225C4.381 10.425 4.031 10.525 3.577 10.525ZM3.977 9.671C4.088 9.573 4.144 9.417 4.144 9.204C4.144 8.991 4.088 8.838 3.974 8.748C3.863 8.657 3.706 8.611 3.504 8.611H2.706V9.819H3.504C3.706 9.819 3.864 9.77 3.977 9.671Z",
			fill: "white"
		})
	]
});
export default SvgPpt;
